import * as React from 'react';
import styled from 'styled-components';
import { Image } from 'antd';
import { BlockHeader } from '../components/BlockHeader';
import { BlockAwards } from '../components/BlockAwards';
import { BlockMembership } from '../components/BlockMembership';
import { BlockNationalPartners } from '../components/BlockNationalPartners';
import { BlockGis } from '../components/BlockGis';

const ImageStyled = styled(Image)`
  width: 100%;
  display: block;
  object-fit: cover;
  z-index: 0;
`;

export const MainPage: React.FC = () => (
    <div style={{ position: 'relative' }}>
        <BlockHeader/>
        <div style={{ height: '50px', backgroundColor: 'white' }}></div>
        <BlockAwards/>
        <div style={{ height: '50px', backgroundColor: 'white' }}></div>
        <BlockMembership/>
        <div style={{ height: '50px', backgroundColor: 'white' }}></div>
         <BlockGis/>
        <div>
            <ImageStyled src={'../img/bars.png'} preview={false}/>
        </div>
        <BlockNationalPartners/>
    </div>
);
